(() => {
  if (window.cftNavigationReady) return;
  window.cftNavigationReady = true;
  const setup = header => {
    if (header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';
    const abort = new AbortController();
    const events = { signal: abort.signal };
    const mobile = header.querySelector('.cft-mobile-menu');
    const submenus = [...header.querySelectorAll('[data-cft-submenu]')];
    const menus = [...submenus, mobile].filter(Boolean);
    const summary = menu => menu.querySelector(':scope > summary');
    const close = (menu, focus = false) => {
      menu.open = false;
      summary(menu)?.setAttribute('aria-expanded', 'false');
      menu.querySelectorAll('[data-cft-submenu]').forEach(child => {
        child.open = false;
        summary(child)?.setAttribute('aria-expanded', 'false');
      });
      if (focus) summary(menu)?.focus({ preventScroll: true });
    };
    const closeAll = () => menus.forEach(menu => close(menu));
    menus.forEach(menu => {
      summary(menu)?.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        summary(menu)?.setAttribute('aria-expanded', String(menu.open));
        if (!menu.open) {
          menu.querySelectorAll('[data-cft-submenu]').forEach(child => close(child));
          return;
        }
        submenus.filter(other => other !== menu && other.parentElement.parentElement === menu.parentElement.parentElement)
          .forEach(other => close(other));
        const search = header.querySelector('[data-search-panel]');
        if (search && !search.hidden) {
          search.querySelector('[data-search-close]')?.click();
          summary(menu)?.focus({ preventScroll: true });
        }
      }, events);
    });
    header.addEventListener('click', event => {
      if (event.target.closest('[data-search-open],a[data-cft-menu-link]')) closeAll();
    }, events);
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) return closeAll();
      submenus.forEach(menu => {
        if (menu.open && !menu.parentElement.contains(event.target)) close(menu);
      });
    }, events);
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !header.querySelector('details[open]')) return;
      const active = document.activeElement?.closest('[data-cft-submenu][open]');
      const menu = active || [...submenus].reverse().find(item => item.open) || (mobile?.open ? mobile : null);
      if (!menu) return;
      event.preventDefault();
      close(menu, true);
    }, events);
    const media = window.matchMedia('(min-width:1081px)');
    media.addEventListener('change', closeAll, events);
    header._cftNavigationDisconnect = () => {
      abort.abort();
      delete header.dataset.navigationReady;
    };
  };
  const scan = root => {
    if (root.matches?.('[data-search-header]')) setup(root);
    root.querySelectorAll('[data-search-header]').forEach(setup);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-search-header]')) event.target._cftNavigationDisconnect?.();
    event.target.querySelectorAll('[data-search-header]').forEach(header => header._cftNavigationDisconnect?.());
  });
})();
